import { useState, useEffect, useCallback, FC } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import XLSX from "xlsx";

import BootstrapTable from 'react-bootstrap-table-next';
import { getUsersByActivitiesObj } from '../../services/NewGroupService';
import ActivityLoading from '../common/ActivityLoading';
import { ActivityStudentFilteredInterface } from '../common/Types';


const ActivityExport: FC = (props: any) => {
    const { location } = props;

    const [students, setStudents] = useState<Array<ActivityStudentFilteredInterface>>([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    const extractStudents = useCallback(async () => {
        const state = location.state ? location.state : undefined;
        if (state !== undefined) {
            let studentsList: any = [];
            if (state && state.data) {
                const activities = state.data.filter((activity: any) => activity.isSelected);
                if (activities.length > 0) {
                    for (let i = 0; i < activities.length; i++) {
                       const res = await getUsersByActivitiesObj(activities[i]).then((response: any) => {return response} );
                        res.forEach((data: any) => {
                            studentsList.push(data);
                        });
                    }
                    setStudents(studentsList as Array<any>);
                    setLoading(false);
                }
            }
        }
    }, [location]);

    const tableColumns = [
        {
            dataField: "actName",
            text: "Actividad"
        },
        {
            dataField: "code",
            text: "Clave"
        },
        {
            dataField: "displayName",
            text: "Nombre"
        },
        {
            dataField: "email",
            text: "Correo electrónico"
        }
    ];

    const exportCsv = () => {
        let ws = XLSX.utils.json_to_sheet(students, {});
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
        let exportFileName = 'Lista_Estudiantes_DE_Cursos.csv';
        XLSX.writeFile(wb, exportFileName);
    };

    useEffect(() => {
        setLoading(true);
        extractStudents();
    }, [extractStudents])

    if (loading) return <ActivityLoading />

    return (
        <Container>
            <div style={{ marginBottom: '15px' }}>
                <Button variant="outline-primary" onClick={() => history.goBack()}>Regresar</Button>
                <Button variant="outline-primary" disabled={students.length === 0 ? true : false} style={{ marginLeft: '10px' }} onClick={() => exportCsv()}>Exportar CSV</Button>
            </div>
            <BootstrapTable id="dtStudents" data={students ? students : []} columns={tableColumns} keyField="code" />
        </Container>
    )
}

export default ActivityExport;